var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitsSubimageIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.109375,
    y: 0.414062,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#F5AEAF",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7148 36.6758H37.2148V30.4258H25.9648V19.1758H19.7148V21.6758H22.2148V24.1758H19.7148V26.6758H23.4648V29.1758H19.7148V31.6758H22.2148V34.1758H19.7148V36.6758H22.2148V34.1758H24.7148V36.6758H27.2148V32.9258H29.7148V36.6758H32.2148V34.1758H34.7148V36.6758ZM28.4648 27.9258H38.4648C38.7964 27.9258 39.1143 28.0575 39.3487 28.2919C39.5831 28.5263 39.7148 28.8443 39.7148 29.1758V37.9258C39.7148 38.2573 39.5831 38.5752 39.3487 38.8097C39.1143 39.0441 38.7964 39.1758 38.4648 39.1758H18.4648C18.1333 39.1758 17.8154 39.0441 17.581 38.8097C17.3465 38.5752 17.2148 38.2573 17.2148 37.9258V17.9258C17.2148 17.5943 17.3465 17.2763 17.581 17.0419C17.8154 16.8075 18.1333 16.6758 18.4648 16.6758H27.2148C27.5464 16.6758 27.8643 16.8075 28.0987 17.0419C28.3331 17.2763 28.4648 17.5943 28.4648 17.9258V27.9258Z",
    fill: "#EC6B6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(13.4648 12.9258)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsSubimageIcon3);
export default __webpack_public_path__ + "static/media/benefits_subimage_icon_3.d6c68f5a25f138cf9bda2c7a5e8ae5ff.svg";
export { ForwardRef as ReactComponent };